import useFeatureToggle from './useFeatureToggle';
import FeatureToggleProvider from './FeatureToggleProvider';

/**
 * Feature toggle framework module.
 *
 * Goal:
 * - keep feature toggle consumption inside framework (`useFeatureToggle`)
 * - inject runtime toggle values via a single app-level provider
 *
 * Usage:
 * - wrap app/root: `<FeatureToggleProvider featureToggles={featureToggles}>...</FeatureToggleProvider>`
 * - consume in components/hooks: `const { isFeatureEnabled } = useFeatureToggle();`
 */
export { FeatureToggleProvider };
export default useFeatureToggle;
